"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typography = void 0;

var _stylitas = require("@creditas/stylitas");

var _fonts = require("./fonts");

var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

var buildertypography = function buildertypography(device) {
  return function (theme, name) {
    var family = theme["".concat(device).concat(name, "Family")];
    var size = theme["".concat(device).concat(name, "Size")];
    var weight = theme["".concat(device).concat(name, "Weight")];
    var lineHeight = theme["".concat(device).concat(name, "LineHeight")];
    var letterSpacing = theme["".concat(device).concat(name, "Spacing")];
    return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n  "])), family, size, weight, lineHeight, letterSpacing);
  };
};

var typographyDesktop = buildertypography('desktop');
var typographyMobile = buildertypography('mobile');

var builderTypographyFns = function builderTypographyFns(typographyFn, typos) {
  return typos.reduce(function (acc, typo) {
    acc[typo] = function (theme) {
      return (0, _stylitas.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", "\n    "])), typographyFn(theme, capitalizeFirstLetter(typo)));
    };

    return acc;
  }, {});
};

var desktop = builderTypographyFns(typographyDesktop, _fonts.typoDesktop);
var mobile = builderTypographyFns(typographyMobile, _fonts.typoMobile);
var typography = {
  desktop: desktop,
  mobile: mobile
};
exports.typography = typography;